import { Outlet } from "react-router-dom";
import BaggageTariffForm from "./BaggageTariffForm";
import BaggageTariffList from "./BaggageTariffList";

export const adminBaggageTariffsRoutes = [
  {
    path: "baggage-tariffs",
    element: Outlet,
    children: [
      {
        path: "",
        element: BaggageTariffList,
      },
      {
        path: "list",
        element: BaggageTariffList,
      },
      {
        path: "add",
        element: BaggageTariffForm,
      },
      {
        path: "edit/:id",
        element: BaggageTariffForm,
      },
    ],
  },
];
